import { render, staticRenderFns } from "./UFCGroupView.vue?vue&type=template&id=0001b77a&scoped=true&"
import script from "./UFCGroupView.vue?vue&type=script&lang=js&"
export * from "./UFCGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0001b77a",
  null
  
)

export default component.exports